import * as yup from 'yup';

const loginSchema = yup.object({
    email: yup.string().email('Błędny email').required('Wymagane pole'),
    password: yup.string().min(6).required('Wymagane pole'),
});

export default loginSchema;
